import { Input as BaseInput, InputProps as BaseInputProps, extendVariants } from '@heroui/react';

export const Input = extendVariants(BaseInput, {
  variants: {
    color: {
      white: {
        inputWrapper: 'bg-white data-[hover=true]:bg-background',
      },
    },
  },
});

export type InputProps = Omit<BaseInputProps, 'color'> & {
  color?: BaseInputProps['color'] | 'white';
};
